import audioCutter from '../views/audioCutter.vue';
import audioCutterPanel from '../components/rightPanel/audioCutterPanel.vue';

export default {
  path: '/audiocutter',
  components: {
    default: audioCutter,
    panel: audioCutterPanel
  }
};
